module.exports = __webpack_public_path__ + "img/AP.32a03765.svg";